import MUIStack, { StackProps } from '@mui/material/Stack';
import React from 'react';

const Stack = React.forwardRef<HTMLDivElement, StackProps>((props, ref) => {
    return <MUIStack ref={ref} {...props} />;
});

export default Stack;
